// extracted by mini-css-extract-plugin
module.exports = {"menu":"UserNavigation_menu__bsnzf"};